import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokens, fonts } from '../theme';

// Native <details> keeps every answer in the page (readable by search engines)
// while staying compact and keyboard accessible.
const Faq = ({ items }) => (
  <Box sx={{ borderTop: `1px solid ${tokens.line}` }}>
    {items.map((item) => (
      <Box
        component="details"
        key={item.q}
        sx={{
          borderBottom: `1px solid ${tokens.line}`,
          '& summary': {
            cursor: 'pointer',
            listStyle: 'none',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
            py: 2.25,
            fontFamily: fonts.display,
            fontWeight: 600,
            fontSize: '1.0625rem',
            color: tokens.text,
            '&::-webkit-details-marker': { display: 'none' },
            '&::after': { content: '"+"', color: tokens.accent, fontSize: '1.4rem', lineHeight: 1 },
            '&:focus-visible': { outline: `2px solid ${tokens.accentStrong}`, outlineOffset: 2, borderRadius: 1 },
          },
          '&[open] summary::after': { content: '"−"' },
        }}
      >
        <Box component="summary">
          <Box component="h3" sx={{ m: 0, font: 'inherit' }}>{item.q}</Box>
        </Box>
        <Typography color="text.secondary" sx={{ pb: 2.5, maxWidth: 720 }}>
          {item.a}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default Faq;
